import React from 'react';

const Footer = () => {
    return(
        <div>
        <footer className="footer text-center">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 mb-5 mb-lg-0">
                        <h4 className="text-uppercase mb-4">Location</h4>
                        <p className="lead mb-0">Lovely Professional University<br />Jalandhar, Punjab, 144411</p>
                    </div>
                    <div className="col-lg-4 mb-5 mb-lg-0">
                        <h4 className="text-uppercase mb-4">Around the Web</h4>
                        <a className="btn btn-outline-light btn-social mx-1" href="https://twitter.com/Sayed_Sajid_Ali"><i className="fab fa-fw fa-twitter"></i></a>
                        <a className="btn btn-outline-light btn-social mx-1" href="https://www.linkedin.com/in/sayed-sajid-ali/"><i className="fab fa-fw fa-linkedin-in"></i></a>
                        <a className="btn btn-outline-light btn-social mx-1" href="https://www.instagram.com/syed_sajidali_/"><i className="fab fa-fw fa-instagram"></i></a>
                        <a className="btn btn-outline-light btn-social mx-1" href="https://github.com/sajidlpu1"><i class="fab fa-github f-size"></i></a>
                    </div>
                    <div className="col-lg-4">
                        <h4 className="text-uppercase mb-4 ">Sayed Sajid Ali</h4>
                        <p className="lead mb-0">Made in <i class="fab fa-react"></i> React.</p>
                    </div>
                </div>
            </div>
        </footer>
        </div>
    );
}


export default Footer;